import {
  ViewRecordDetails,
  ViewRecordHeader,
  useViewRecordDetails,
} from "../../components/Drawers/Records/ViewRecordDrawer";
import useModule from "../../hooks/useModule";
import useView from "../../api/api-hooks/views/useView";
import { useNavigate, useParams } from "react-router-dom";
import TransformRecordDrawer from "../../components/Drawers/Records/TransformRecordDrawer";
import { useState } from "react";

/**
 * Page dedicated to viewing the details of a record, and record tabs.
 * Supports SubView tabs for the record, when a PageID and ViewID is provided.
 */
export default function RecordDetailView() {
  const { tenantID, recordID, ModuleAPIName, tab, pageID, viewID }: any =
    useParams();
  const { view } = useView({ pageID, viewID });
  const { module } = useModule(ModuleAPIName);
  const navigate = useNavigate();
  const [dtModal, setModal] = useState(false);
  const [updateRecordDrawer, setUpdateRecordDrawer] = useState(false);

  const {
    record,
    recordLoading,
    activeTab,
    setActiveTab,
    currentSubitemField,
    currentRichTextField,
    layout,
    setLayout,
  } = useViewRecordDetails({
    open: !!recordID && !!module,
    recordID,
    module,
    tab,
    viewID: viewID || "details",
  });

  // Handle different URL types, including when pageID/viewID is provided
  const handleTabChange = (newTab: string) => {
    setActiveTab(newTab);
    if (pageID && viewID) {
      navigate(
        `/clouds/${tenantID}/pages/${pageID}/views/${viewID}/records/${ModuleAPIName}/details/${recordID}/${newTab}`,
        { replace: true }
      );
    } else {
      navigate(
        `/clouds/${tenantID}/records/${ModuleAPIName}/details/${recordID}/${newTab}`,
        { replace: true }
      );
    }
  };

  return (
    <div className="py-3 px-4">
      <div className="mb-3 mx-4">
        <ViewRecordHeader
          record={record}
          recordID={recordID}
          recordLoading={recordLoading || !recordID || !module}
          module={module}
          layout={layout}
          activeTab={activeTab}
          handleTabChange={handleTabChange}
          view={view || undefined}
          updateRecordDrawer={updateRecordDrawer}
          setUpdateRecordDrawer={setUpdateRecordDrawer}
        />
      </div>
      <div className="mx--2">
        <ViewRecordDetails
          recordLoading={recordLoading}
          record={record}
          recordID={recordID}
          layout={layout}
          module={module}
          setLayout={setLayout}
          activeTab={activeTab}
          currentSubitemField={currentSubitemField}
          currentRichTextField={currentRichTextField}
          parentViewID={viewID}
          setUpdateRecordDrawer={setUpdateRecordDrawer}
        />
      </div>
      <TransformRecordDrawer
        open={dtModal}
        onClose={() => setModal(false)}
        sourceRecordID={recordID}
        module={module}
      />
    </div>
  );
}
